import DriverOverviewService from "@/services/DriverOverviewService";
import { formatDate, unformatDate } from "@/utils/dates";

const getDefaultState = () => {
    return {
        allDrivers: [],
        driversByDate: {
            data: [],
            from: new Date().toISOString().substring(0, 10),
            to: new Date().toISOString().substring(0, 10),
            defaultFrom: new Date().toISOString().substring(0, 10),
            defaultTo: new Date().toISOString().substring(0, 10),
        },
    };
};
export default {
    state: () => getDefaultState(),
    getters: {
        getAllDrivers: state => state.allDrivers,
        getDriversByDate: state => state.driversByDate.data,
        isDriverDateFromDefault: state =>
            state.driversByDate.from === state.driversByDate.defaultFrom,
        isDriverDateToDefault: state =>
            state.driversByDate.to === state.driversByDate.defaultTo,
    },
    mutations: {
        setAllDrivers: (state, allDrivers) => {
            state.allDrivers = allDrivers;
        },
        setDriversByDate: (state, driversByDate) => {
            state.driversByDate.data = driversByDate;
            for (const elem of state.driversByDate.data) {
                const dateTime = elem.created_at.split(" ");
                elem.intCreatedAt = new Date(
                    `${unformatDate(dateTime[0])}T${dateTime[1]}`
                ).getTime();
            }
        },
        setDriversState: state => {
            Object.assign(state, getDefaultState());
        },
    },
    actions: {
        processAllDrivers: async ({ dispatch, commit }) => {
            try {
                commit("setLoading", true);
                const response = await DriverOverviewService.get();
                commit("setAllDrivers", response.data.data);
            } catch (e) {
                if (e.response.data.message === "Objects were not found") {
                    commit("setAllDrivers", []);
                } else {
                    dispatch("generalErrorHandling", e);
                }
            } finally {
                commit("setLoading", false);
            }
        },

        processDriversByDate: async ({ state, dispatch, commit }) => {
            try {
                commit("setLoading", true);
                const response = await DriverOverviewService.getByDate(
                    formatDate(state.driversByDate.from),
                    formatDate(state.driversByDate.to)
                );
                commit("setDriversByDate", response.data.data);
            } catch (e) {
                if (e.response.data.message === "Objects were not found") {
                    commit("setDriversByDate", []);
                } else {
                    dispatch("generalErrorHandling", e);
                }
            } finally {
                commit("setLoading", false);
            }
        },

        undoDriver: async ({ dispatch, commit }, id) => {
            try {
                commit("setLoading", true);
                await dispatch("setStatus", { id, status: 0 });
                await dispatch("processArchive");
                commit({
                    type: "alert",
                    text: "UNDO Successful",
                    color: "",
                    icon: "check_circle",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        modifyDescription: async ({ dispatch, commit }, driver) => {
            try {
                commit("setLoading", true);
                await DriverOverviewService.update(driver.visitor_id, driver);
                await dispatch("processDriversByDate");
                commit({
                    type: "alert",
                    text: "Description Saved Successfully",
                    color: "success",
                    icon: "check_circle",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        setStatus: async ({ dispatch, commit }, driver) => {
            try {
                commit("setLoading", true);
                await DriverOverviewService.updateStatus(
                    driver.id,
                    driver.status
                );
                await dispatch("processDriversByDate");
                if (driver.status === 0) {
                    commit({
                        type: "alert",
                        text: "Status changed to Not Set",
                        color: "",
                        icon: "info",
                    });
                } else if (driver.status === 1) {
                    commit({
                        type: "alert",
                        text: "Status changed to Pre-Registered",
                        color: "success",
                        icon: "check_circle",
                    });
                } else {
                    commit({
                        type: "alert",
                        text: "Status changed to Not Pre-Registered",
                        color: "warning",
                        icon: "warning",
                    });
                }
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        resetDriverOverviewState: ({ commit }) => {
            commit("setDriversState");
        },

        editDriverOverview: async ({ dispatch, commit }, driver) => {
            try {
                commit("setLoading", true);

                await DriverOverviewService.update(driver.visitor_id, driver);
                await dispatch("processDriversByDate");

                //console.log(driver);

                commit({
                    type: "alert",
                    text: "Driver Overview changes saved",
                    color: "primary",
                    icon: "save",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },
    },
};
